export default __webpack_public_path__ + "static/char-11-anr-d2af0510eec65e7e913af63f10058fb8.gif";